import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductPageVolumePricingModalNotification } from './ProductPageVolumePricingModalNotification'
import { ProductPageVolumePricingModalTable } from './ProductPageVolumePricingModalTable'

export const ProductPageVolumePricingModal: FC<{
  isOpen: boolean
  onClose: () => void
  volumePrices: VolumeBasedPriceV1[]
}> = ({ isOpen, onClose, volumePrices }) => {
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="volumePricing.modal.title" />
      </DialogTitle>
      <DialogContent>
        <div className="max-w-[640px]">
          <ProductPageVolumePricingModalNotification />
          <ProductPageVolumePricingModalTable volumePrices={volumePrices} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
